/** Default shape for clients.entity_profile (JSONB). Used for SEO / schema.org / llms.txt style data. */

export const ENTITY_TYPES = [
  { value: 'RoofingService', label: 'Roofing Service' },
  { value: 'HomeAndConstructionBusiness', label: 'Home & Construction Business' },
  { value: 'LocalBusiness', label: 'Local Business' },
];

export function defaultEntityProfile() {
  return {
    legal_name: '',
    entity_type: 'LocalBusiness',
    founding_date: '',
    logo_url: '',
    hq_address: { street: '', city: '', state: '', zip: '' },
    branch_locations: [],
    primary_phone: '',
    service_area: [],
    expertise: [],
    authority_links: [],
    ai_summary: '',
    priority_pages: [],
    credentials: [],
  };
}

/** Merge DB value with defaults (safe for partial / null). */
export function mergeEntityProfile(raw) {
  const d = defaultEntityProfile();
  if (!raw || typeof raw !== 'object') return d;
  return {
    ...d,
    ...raw,
    hq_address: { ...d.hq_address, ...(raw.hq_address && typeof raw.hq_address === 'object' ? raw.hq_address : {}) },
    branch_locations: Array.isArray(raw.branch_locations) ? raw.branch_locations.map(normalizeBranch) : [],
    service_area: Array.isArray(raw.service_area) ? raw.service_area.map(String) : [],
    expertise: Array.isArray(raw.expertise) ? raw.expertise.map(String) : [],
    authority_links: Array.isArray(raw.authority_links) ? raw.authority_links.map(String) : [],
    priority_pages: Array.isArray(raw.priority_pages) ? raw.priority_pages.map(normalizePage) : [],
    credentials: Array.isArray(raw.credentials) ? raw.credentials.map(normalizeCred) : [],
  };
}

function normalizeBranch(b) {
  if (!b || typeof b !== 'object') return { label: '', street: '', city: '', state: '', zip: '' };
  return {
    label: b.label != null ? String(b.label) : '',
    street: b.street != null ? String(b.street) : '',
    city: b.city != null ? String(b.city) : '',
    state: b.state != null ? String(b.state) : '',
    zip: b.zip != null ? String(b.zip) : '',
  };
}

function normalizePage(p) {
  if (!p || typeof p !== 'object') return { title: '', url: '' };
  return { title: p.title != null ? String(p.title) : '', url: p.url != null ? String(p.url) : '' };
}

function normalizeCred(c) {
  if (!c || typeof c !== 'object') return { site: '', login: '', password: '' };
  return {
    site: c.site != null ? String(c.site) : '',
    login: c.login != null ? String(c.login) : '',
    password: c.password != null ? String(c.password) : '',
  };
}

/** Parse comma/newline separated tags into trimmed non-empty strings. */
export function parseTags(text) {
  if (!text || typeof text !== 'string') return [];
  return text.split(/[\n,]+/).map(s => s.trim()).filter(Boolean);
}

export function tagsToText(arr) {
  if (!Array.isArray(arr)) return '';
  return arr.join(', ');
}
